import { createContext, useContext } from 'react';
import type { BetaNavItemKey } from './SecondaryNav';

type BetaSecondaryNavContextValue = {
  selectedItemKey: BetaNavItemKey | null;
  expandedSectionKeys: BetaNavItemKey[];
  registerSelectedItemKey: (key: BetaNavItemKey | null) => void;
  registerExpandedSectionKeys: (keys: BetaNavItemKey[]) => void;
};

export const BetaSecondaryNavContext = createContext<
  BetaSecondaryNavContextValue | undefined
>(undefined);

export const useSecondaryNavContext = () => {
  const context = useContext(BetaSecondaryNavContext);
  if (context === undefined) {
    throw new Error(
      'useSecondaryNavContext must be used within a BetaSecondaryNavContext (which is available by using BetaSecondaryNav)'
    );
  }
  return context;
};
